import React, { useState } from "react";
import "./PatientDetails.css";
import { useTranslation } from "react-i18next";
import Icons from "../../../../Assets/Icons";
import { format } from "date-fns";
import Widgets from "../../../../widgets";

const PatientDetails = ({ setPage }) => {
  const { t } = useTranslation();
  const [rawDate] = useState("2004-05-02");
  const [patientCondition, setPatientCondition] = useState("");
  const [zone, setZone] = useState("");
  const [showVerifyAddress, setShowVerifyAddress] = useState(false);

  const [pdfFile, setPdfFile] = useState("https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf");

  const getFormattedDate = (date) => {
    let dateObj = new Date(date);
    return format(dateObj, "dd MMM, yyyy");
  };

  const handleZoneChange = (e) => {
    setZone(e.target.value.trimStart());
  };

  const handleVerifyAddCancel = () => {
    setShowVerifyAddress(false);
  };
  const handleVerifyAddConfirm = () => {
    setShowVerifyAddress(false);
  };

  const handleOpenInNewTab = () => {
    // Opens the PDF in a new tab for preview
    window.open(pdfFile, "_blank");
  };

  return (
    <div className="verification-request">
      <div className="pdl-info verify">
        <p className="pdl-title">{t("personalInformation")}</p>
        <div className="pdl-body">
          <div className="pdl-section-left">
            <img src={Icons.noProfile} alt="profile" />
            <p className="pdl-name">
              Gaurav Kumar <span className="span-gender">Male</span>
            </p>
            <p className="sd-hn">HN: 889988998</p>
            <p className="sd-hn">
              <img src={Icons.redPlus} alt="location" /> International Insured
            </p>
          </div>
          <div className="pdl-section-right">
            <section className="pdl-phone-dob nc-sd-patient">
              <div className="pdl-detail">
                <img src={Icons.Call} alt="call" />
                <span>
                  +{"91"} {"8797830315"}
                </span>
              </div>
              <div className="pdl-detail date-pick">
                <img src={Icons.CalenderIcon} alt="calender" />
                <span>{getFormattedDate(rawDate)}</span>
              </div>
            </section>
            <section className="pdl-phone-dob nc-sd-patient nc-sd-address">
              <div className="pdl-detail">
                <img src={Icons.SmsIcon} alt="mail" />
                <span>{"gaurav.k@myclnq.co.in"}</span>
              </div>
              <div className="pdl-detail nc-sd-address">
                <img src={Icons.Location} alt="location" />
                <span>{"No. 1, Nguyen Tat Thanh Street, Ward 12, District 4, Ho Chi Minh City, Vietnam"}</span>
              </div>
            </section>
            <section className="verify-address">
              <span onClick={() => setShowVerifyAddress(true)}>{t("verifyAddress")}</span>
            </section>
            <section className="pdl-phone-dob nc-sd-dropdown">
              <div className="pdl-hn sd-half">
                <p className="pdl-hn-title">
                  {t("patientCondition")}
                  <span className="asterik">*</span>
                </p>
                <Widgets.SelectDropdown
                  options={[`${t("wheelchairBound")}`, `${t("mentalHealth")}`, `${t("autism")}`, `${t("specialCare")}`]}
                  selectedValue={patientCondition}
                  onChange={setPatientCondition}
                  placeholder="selPatientCondi"
                  big
                />
              </div>
              <div className="pdl-hn sd-half">
                <p className="pdl-hn-title">
                  {t("zone")}
                  <span className="asterik">*</span>
                </p>
                <input type="text" name="zone" className="pdl-number" value={zone} onChange={handleZoneChange} disabled={false} placeholder={t("enterPatZone")} />
              </div>
            </section>
          </div>
        </div>
        <div>
          {pdfFile && (
            <div>
              <button onClick={handleOpenInNewTab}>Open in New Tab</button>
            </div>
          )}
        </div>
        <div></div>
      </div>
      <Widgets.ConfirmModal
        showModal={showVerifyAddress}
        handleCancel={handleVerifyAddCancel}
        handleConfirm={handleVerifyAddConfirm}
        heading="verifyAddress"
        description="askVerifyAdd"
        postive
        reject
      />
    </div>
  );
};

export default PatientDetails;
